import { IPreloadedState } from 'shared/types/redux';

export const selectPromoSearchTypes = (state: IPreloadedState) => state.promoSearchTypes;
